<template>
  <div class="unsubscribe-page">
    <div class="unsubscribe-page__card">

      <!-- invalid link -->
      <template v-if="state === 'invalid'">
        <h1 class="unsubscribe-page__title">{{ $t('unsubscribe.invalidTitle') }}</h1>
        <p class="unsubscribe-page__text">{{ $t('unsubscribe.invalidText') }}</p>
      </template>

      <!-- confirm (default): no action happens on page load, so email security
           scanners that prefetch links can never unsubscribe someone -->
      <template v-else-if="state === 'confirm'">
        <h1 class="unsubscribe-page__title">{{ $t('unsubscribe.confirmTitle') }}</h1>
        <p class="unsubscribe-page__text">{{ $t('unsubscribe.confirmText') }}</p>
        <base-button type="primary" @click="unsubscribe">
          {{ $t('unsubscribe.confirmButton') }}
        </base-button>
      </template>

      <!-- working -->
      <template v-else-if="state === 'loading'">
        <i class="el-icon-loading unsubscribe-page__loader"></i>
        <p class="unsubscribe-page__text">{{ $t('unsubscribe.working') }}</p>
      </template>

      <!-- done -->
      <template v-else-if="state === 'done'">
        <h1 class="unsubscribe-page__title">{{ $t('unsubscribe.doneTitle') }}</h1>
        <p class="unsubscribe-page__text">{{ $t('unsubscribe.doneText') }}</p>
      </template>

      <!-- error -->
      <template v-else>
        <h1 class="unsubscribe-page__title">{{ $t('unsubscribe.errorTitle') }}</h1>
        <p class="unsubscribe-page__text">{{ $t('unsubscribe.errorText') }}</p>
        <base-button type="primary" @click="unsubscribe">
          {{ $t('unsubscribe.retryButton') }}
        </base-button>
      </template>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { API_LOCATION } from '@/api-config'

export default {
  name: 'Unsubscribe',
  data() {
    return {
      state: 'confirm'
    }
  },
  created() {
    const q = this.$route.query
    if (!q.e || !q.c || !q.t) {
      this.state = 'invalid'
    }
  },
  methods: {
    async unsubscribe() {
      this.state = 'loading'
      try {
        const q = this.$route.query
        const params = new URLSearchParams({ e: q.e, c: q.c, t: q.t })
        if (q.cid) params.append('cid', q.cid)
        // POST with no body: a CORS simple request, and the same endpoint mail
        // providers hit for RFC 8058 one-click unsubscribe
        await axios.post(`${API_LOCATION}unsubscribe?${params.toString()}`)
        this.state = 'done'
      } catch (err) {
        if (err.response && err.response.status === 400) {
          this.state = 'invalid'
        } else {
          this.state = 'error'
        }
      }
    }
  }
}
</script>

<style scoped>
.unsubscribe-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.unsubscribe-page__card {
  max-width: 480px;
  width: 100%;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
  padding: 40px 32px;
  text-align: center;
}

.unsubscribe-page__title {
  font-size: 22px;
  color: #1d1d1f;
  margin-bottom: 16px;
}

.unsubscribe-page__text {
  font-size: 15px;
  line-height: 1.5;
  color: #555555;
  margin-bottom: 24px;
}

.unsubscribe-page__loader {
  font-size: 28px;
  color: #e14eca;
  display: block;
  margin-bottom: 16px;
}
</style>
